import { render, staticRenderFns } from "./airRealList.vue?vue&type=template&id=207b8d2b&"
import script from "./airRealList.vue?vue&type=script&lang=js&"
export * from "./airRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207b8d2b')) {
      api.createRecord('207b8d2b', component.options)
    } else {
      api.reload('207b8d2b', component.options)
    }
    module.hot.accept("./airRealList.vue?vue&type=template&id=207b8d2b&", function () {
      api.rerender('207b8d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceReal/components/PriceReal/airRealList.vue"
export default component.exports